import { Analytics } from '@cobliteam/analytics';

import Icon from '@cobliteam/ui/icons';

import Button from '@cobliteam/ui/components/Button';

interface DataTableRefreshProps {
  onRefresh?: () => void;
  isFetching?: boolean;
}

const DataTableRefresh = ({ onRefresh, isFetching }: DataTableRefreshProps) => {
  if (!onRefresh) return null;

  const handleRefresh = () => {
    Analytics.track('DataTable Refresh Button Clicked');
    onRefresh();
  };

  return (
    <Button
      data-testid='refresh-button'
      size='sm'
      loading={isFetching}
      disabled={isFetching}
      color='default'
      variant='outlined'
      icon={<Icon name='rotate-cw' />}
      onClick={handleRefresh}
    />
  );
};

export default DataTableRefresh;
